import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/work/english/new-evaluation/src/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'grade',
  data: function data() {
    return {
      tableData: [],
      loading: false
    };
  },
  mounted: function mounted() {
    this.loadTableData();
  },
  methods: {
    loadTableData: function loadTableData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _this.loading = true;
                _context.next = 4;
                return _this.$api.loadGradeList();

              case 4:
                res = _context.sent;
                res.forEach(function (e) {
                  e.isEdit = false;
                });
                _this.tableData = res;
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);

              case 12:
                _context.prev = 12;
                _this.loading = false;
                return _context.finish(12);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9, 12, 15]]);
      }))();
    },
    edit: function edit(row) {
      row.isEdit = true;
    },
    cancel: function cancel(row) {
      row.isEdit = false;
    },
    save: function save(row) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                params = new URLSearchParams();

                if (row.id) {
                  params.set('id', row.id);
                }

                params.set('grade', row.grade);
                params.set('orderIndex', row.orderIndex);
                _context2.next = 7;
                return _this2.$api.saveGrade(params.toString());

              case 7:
                res = _context2.sent;
                res.forEach(function (e) {
                  e.isEdit = false;
                });
                _this2.tableData = res;

                _this2.$message({
                  message: '保存成功',
                  type: 'success'
                });

                _context2.next = 17;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);

                _this2.$message({
                  message: '保存失败',
                  type: 'error'
                });

                console.log(_context2.t0);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 13]]);
      }))();
    },
    add: function add() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.tableData.push({
                  grade: '',
                  orderIndex: 0,
                  isEdit: true
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};